export const getAuthBaseUrl = (): void => {
  return window.API_CONFIG?.api.auth?.baseUrl;
};
